import Vue from 'vue';
import moment from 'moment';
import Enums from './enums';

function getEnumMember(enumClass, enumValue) {
  for (const val in enumClass) {
    if (enumClass[val].value == enumValue) return enumClass[val];
  }
  return {};
}
Vue.filter("CarOwnership", (enumValue) => {
  const enumObj = getEnumMember(Enums.CarOwnership, enumValue);
  return enumObj.text;
});

Vue.filter("ToDate", (date) => moment(date).format('YYYY-MM-DD'));

Vue.filter("ToTime", (date) => moment(date).format('LT'));
Vue.filter("localdate", (date) => {
  const newDate = new Date(new Date(date).getTime() + new Date(date).getTimezoneOffset() * 60 * 1000);
  const offset = new Date(date).getTimezoneOffset() / 60;
  const hours = new Date(date).getHours();
  newDate.setHours(hours - offset);
  return moment(newDate).format('LT');
});

Vue.filter("EnumMember", (enumValue, enumClass) => getEnumMember(enumClass, enumValue));
Vue.filter("PaymentTypes", (enumValue) => {
  const enumObj = getEnumMember(Enums.PaymentTypes, enumValue);
  return enumObj.text;

});
Vue.filter("PaymentPaidTypes", (enumValue) => {
  const enumObj = getEnumMember(Enums.PaymentPaidTypes, enumValue);
  return enumObj.text;

});
Vue.filter("Cities", (enumValue) => {
  const enumObj = getEnumMember(Enums.Cities, enumValue);
  return enumObj.text;

});
Vue.filter("ShipmentsReportsStatesnc", (enumValue) => {
  const enumObj = getEnumMember(Enums.ShipmentsReportsStatesnc, enumValue);
  return enumObj.text;

});
Vue.filter("ShipmentsReportsTypes", (enumValue) => {
  const enumObj = getEnumMember(Enums.ShipmentsReportsTypes, enumValue);
  return enumObj.text;

});
Vue.filter("mcashingSide", (enumValue) => {
  const enumObj = getEnumMember(Enums.mcashingSide, enumValue);
  return enumObj.text;

});
Vue.filter("ExpenseReceiptPaymentTypes", (enumValue) => {
  const enumObj = getEnumMember(Enums.ExpenseReceiptPaymentTypes, enumValue);
  return enumObj.text;

});
Vue.filter("Sizes", (enumValue) => {
  const enumObj = getEnumMember(Enums.Sizes, enumValue);
  return enumObj.text;

});

Vue.filter("RecipientTypes", (enumValue) => {
  const enumObj = getEnumMember(Enums.RecipientType, enumValue);
  return enumObj.text;

});

Vue.filter("DiscountTypes", (enumValue) => {
  const enumObj = getEnumMember(Enums.DiscountTypes, enumValue);
  return enumObj.text;

});
